import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnalyticsStore } from '@/store/analytics.store';
import { usePipelineStore } from '@/store/pipeline.store';
import { ExtensionPrompt } from '@/components/ExtensionPrompt';
import { Button } from '@/components/common';
import {
  WelcomeHeader,
  QuickStatsBar,
  ScoreGauge,
  ActivityFeed,
  ApplicationFunnel,
  ProfileCompleteness,
} from '@/components/analytics';
import '@/styles/analytics.css';

export default function AnalyticsPage() {
  const recompute = useAnalyticsStore((s) => s.recompute);
  const totalJobs = usePipelineStore((s) => s.jobs.length);
  const navigate = useNavigate();

  // Recompute analytics from pipeline data on mount
  useEffect(() => {
    recompute();
  }, [recompute]);

  // Empty state: no jobs in pipeline yet
  if (totalJobs === 0) {
    return (
      <div className="analytics-page">
        <WelcomeHeader />
        <div className="bg-surface border border-border rounded-lg p-8 sm:p-12 text-center">
          <svg
            className="w-16 h-16 mx-auto mb-4 text-text-secondary opacity-40"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
          <h2 className="text-xl font-semibold text-text-primary mb-2">
            No analytics data yet
          </h2>
          <p className="text-text-secondary mb-6 max-w-md mx-auto">
            Analytics are generated from your job pipeline. Add jobs to start tracking match scores, application stages, and more.
          </p>
          <Button onClick={() => navigate('/app/pipeline')}>
            Go to Pipeline
          </Button>
        </div>
        <ProfileCompleteness />
      </div>
    );
  }

  return (
    <div className="analytics-page">
      <WelcomeHeader />
      <QuickStatsBar />

      <div className="analytics-main-grid">
        <ScoreGauge />
        <ActivityFeed />
      </div>

      <div className="analytics-bottom-grid">
        <ApplicationFunnel />
        <ProfileCompleteness />
      </div>

      <div className="mt-6">
        <ExtensionPrompt variant="analytics" />
      </div>
    </div>
  );
}
